/******************************************************
 *                  Open-iti import
 ********************************************************/

"use strict";

angular.module("exploitation")
	.controller( "ImportGtfsParametersCtrl", ["$scope", "Utils", "$uibModal", function ($scope, Utils, $uibModal) {
		$scope.data = {
		};

		$scope.updateMapMatchingState = function() {
			if ($scope.formData.importShapesFile === 'true' && !$scope.formData.routesReorganization) {
				$scope.formData.generateMapMatching = 'NONE';
			}
		};

		$scope.onRouteMergeChange = function() {
			if (!$scope.formData.routeMerge) {
				$scope.formData.splitCharacter = "";
			}
		};

		$scope.openOverwriteLineInformationModal = function() {
			Utils.openModal($uibModal, "overwriteLineInformationModal.html", $scope);
		};
	}]);